import React from "react";

function Vogel() {
    return(
        <h1>
        This si the vogel page</h1>
    );
}

export default Vogel